import { Currencies, LanguageCodes } from "../../DTOs";

export const basicValidation = {
    date:validateDate,
    dateOrNull:validateDateOrNull,
    arrayStringsAreUnique,
    validateString,
    validateTextString,
    validateInteger,
    validateIntegerString,
    validateBoolean,
    validateLanguageCode,
    isValidEmail,
    isValidEmailDomain,
    isValidPassword,
    isValidPhoneNumber,
    isValidText,
    isValidUrl,
    isValidFileFolderName,
    isValidFileName,
    resourceId:{
        isValid:resourceIdIsValid,
        isValidOrEmpty:resourceIdIisValidOrEmpty
    },
    resourceText:{
        isValid:resourceTextIsValid
    },
    stringValuesAreUnique,
    validateStringArray,
    validateFlags,
    validateCurrency
}

function validateCurrency(value: string): boolean {
    return typeof value === 'string' && Currencies.some(c => c === value);
}

function validateFlags(allowedFlags: readonly string[], values: unknown): boolean {
    return Array.isArray(values)
        && values.every(value => typeof value === 'string' && allowedFlags.some(flag => flag === value))
        && arrayStringsAreUnique(values);
}

function validateDate(dt: Date) {
    return dt != null && dt !== undefined && dt.getMonth !== undefined && typeof dt.getMonth === 'function';
}

function validateDateOrNull(dt: Date | null) {
    if (dt === null) return true;
    return validateDate(dt)
}

function arrayStringsAreUnique(strings: string[]) {
    return new Set(strings).size === strings.length;
}

function validateStringArray(values:string[], maxStringLength:number) {
    return Array.isArray(values) && values.every(value => validateString(value, false, false, 0, maxStringLength));
}


function validateString(value: string, allowNull: boolean, allowUndefined: boolean, minLength:number, maxLength:number) {
    if (value === null) return allowNull;
    if (value === undefined) return allowUndefined;
    return typeof value === 'string' &&
        value.length >= minLength &&
        value.length <= maxLength;
}

function validateTextString(value:string, minLength:number, maxLength:number)
{
    if(!validateString(value, false, false, minLength, maxLength))
        return false;

    return new RegExp("^[A-Za-zÀ-ȕ0-9 \\n_.,;:!?()-]*$").test(value);
}

function validateInteger(value: number, min: number, max: number) {
    return value !== null && value !== undefined
        && Number.isInteger(value)
        && value >= min && value <= max;
}

function validateIntegerString(str: string): boolean {
    if (typeof str !== 'number' && typeof str !== 'string')
        return false;
    if (str === '')
        return false;
    if (/\s/g.test(str))
        return false;
    
    return Number.isInteger(Number(str));
}

function validateBoolean(bool: boolean | null) {
    return bool!==null && bool!==undefined && typeof bool === 'boolean';
}

function validateLanguageCode(language: string) {
    return LanguageCodes.find(l => l === language) !== undefined
}

function isValidEmail(email: string, allowEmpty?:boolean): boolean {
    if(email === null || email === undefined)
        return false;

    if(email === '')
        return allowEmpty || false;

    return email.length > 0 && email.length <= 100
        && new RegExp(/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/).test(email || '');
}

function isValidEmailDomain(domain: string): boolean 
{
    return domain.length > 0 && domain.length <= 100
        && new RegExp(/^[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/).test(domain || '');
}

function isValidPassword(password: string): boolean {
    return typeof password === 'string'
        && new RegExp(/^\S{7,100}$/).test(password || '');
}

function isValidPhoneNumber(number:string, allowEmpty:boolean): boolean {
    if(number === null || number === undefined)
        return false;

    if(number === '')
        return allowEmpty;
    
    return new RegExp(/^\+?[0-9 -]{8,20}$/).test(number || '');
}

function isValidText(text: string, maxLength: number, allowEmpty: boolean): boolean {
    // TODO: Test text ikke indeholder markup eller scripts
    return typeof(text)==='string' && text.length <= maxLength && (allowEmpty || text !== '');
}

export function isValidUrl(str:string, allowEmpty:boolean, maxLength:number): boolean {
    if(str === null || str === undefined)
        return false;
    
    if(str === '')
        return allowEmpty;

    if(str.length > maxLength)
        return false;
    
    // Changes to this may make ReferenceLinks fail-lock,
    // since a collection of links is submitted and validated before saving.
    // If one link fails, none are saved and the entire collection is saved at the same time.

    // Therefore, ReferenceLink validation does not use this code !!

    try {
        //return validUrl.isUri(str) !== undefined;
        const re = /^https?:\/\/[^\s]+$/i;
        return re.test(str);
    } 
    catch (_) {
        return false;  
    }
}

export function isValidFileFolderName(str:string): boolean {
    if(str === null || str === undefined || str === '')
        return false;

    // eslint-disable-next-line no-control-regex
    const illegalChars = /[<>:"/\\|?*\x00-\x1F]|^(?:aux|con|clock\$|nul|prn|com[1-9]|lpt[1-9])$/i;
    if(illegalChars.test(str))
        return false;
    
    try {
        const re = /^[a-zA-Z0-9_-æøåÆØÅ][a-zA-Z0-9_ -æøåÆØÅ]*[a-zA-Z0-9_-æøåÆØÅ]$/;
        return re.test(str) && str.length <= 100;
    } 
    catch (_) {
        return false;  
    }
}

function isValidFileName(value:string, maxLength:128|256): boolean {
// eslint-disable-next-line no-control-regex
    const filenameReservedRegex = /[<>:"/\\|?*\u0000-\u001F]/g;
    const windowsReservedNameRegex =  /^(con|prn|aux|nul|com\d|lpt\d)$/i;

    if(value === null || value === undefined || typeof value !== 'string') {
        return false;
    }

    if (!value || value.length > maxLength) {
        return false;
    }

    if (filenameReservedRegex.test(value) || windowsReservedNameRegex.test(value)) {
        return false;
    }

    if(!value)

    if (value === '' ||value === '.' || value === '..') {
        return false;
    }

    const sections = value.split('.');
    if(sections.length < 2)
        return false;

    if (filenameReservedRegex.test(sections[0]) || windowsReservedNameRegex.test(sections[0])) {
        return false;
    }

    // Catches '.', 'x.', '.x'
    if(sections.some(i => i === ''))
        return false;

    if(sections.some(i => i.startsWith(' ') || i.endsWith(' ')))
        return false;

    return true;
}

function resourceIdIsValid(maybeId: string, length?:number): boolean  
{
    return typeof maybeId === 'string'
        && maybeId !== null
        && maybeId !== undefined
        && new RegExp(`^[a-zA-Z0-9_-]{1,${length || 36}}$`).test(maybeId);
}

function resourceIdIisValidOrEmpty(maybeId:string):boolean
{
    return maybeId === '' || resourceIdIsValid(maybeId);
}

function resourceTextIsValid(value: string, allowEmpty?:boolean, maxLength?:number): boolean
{
    if(value === undefined || value === null)
        return false;

    if(typeof value !== 'string')
        return false;

    const appliedMaxLength = maxLength || 100;
    
    if(value === '')
        return allowEmpty || false;

    return value !== null
        && value !== undefined
        && value.length <= appliedMaxLength;
}

function stringValuesAreUnique(values:string[])
{
    const duplicates = values.filter((item, index) => values.indexOf(item) != index);
    return duplicates.length === 0;
}